import React from "react";

const defaultGlobalRights = {};
export const GlobalRightsContext = React.createContext(defaultGlobalRights);
